import {
  Row,
  Col,
  Form,
  Modal,
  Table,
  Button,
  Input,
  Select,
  Tree,
  Space,
  Spin,
  message
} from 'antd'
import { SearchOutlined, ReloadOutlined, PlusOutlined } from '@ant-design/icons'
import service from '../../../@services'
import { useEffect, useState } from 'react'
const statusMap = {
  0: '下架',
  1: '上架',
  2: '紧急下架',
  3: '草稿'
}
export default function ProductSearchModal(props) {
  const {
    visible,
    close = () => {},
    confirm = () => {},
    confirmListHaveInfo = () => {},
    create = null,
    otherTips = '',
    storeCode = null,
    storeId = null
  } = props
  const [form] = Form.useForm()
  const [treeLoading, setTreeLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [searchType, setSearchType] = useState(1)
  const [TreeData, setTreeData] = useState([])
  const [fieldNames, setFieldNames] = useState({})
  const [tableData, setTableData] = useState([])
  const [selectTreeCode, setSelectTreeCode] = useState()
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [selectedRowKeys, onSelectChange] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  useEffect(() => {
    searchType && onSearchTypeChange()
  }, [searchType])
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys, selectedRows) => {
      onSelectChange(selectedRowKeys)
      setSelectedRows(selectedRows)
    }
  }
  const onSearch = () => {
    onSelectChange([])
    setSearchType()
    const params = Object.assign(
      { storeCode, storeId },
      form.getFieldsValue(),
      {
        pageIndex: 1,
        pageSize: 10
      }
    )
    fetchData(params)
  }
  const onReset = () => {
    form.resetFields()
  }
  const handleTableChange = pagination => {
    setPagination(pagination)
    const params = Object.assign(
      { storeCode, storeId },
      searchType === 1
        ? { categoryCode: selectTreeCode }
        : searchType === 2
        ? { brandId: selectTreeCode }
        : form.getFieldsValue(),
      {
        pageIndex: pagination.current,
        pageSize: pagination.pageSize
      }
    )
    fetchData(params)
  }
  const fetchData = async params => {
    setLoading(true)
    const data = await service.common.queryMerchantProductList(params)
    setLoading(false)
    if (data) {
      setTableData(data.result)
      setPagination({
        current: data.pageIndex,
        pageSize: data.pageSize,
        total: data.recordCount
      })
    }
  }
  const onSearchTypeChange = async () => {
    setTreeLoading(true)
    onSelectChange([])
    const fieldNames =
      searchType === 1
        ? { title: 'categoryName', key: 'categoryCode', children: 'children' }
        : { title: 'name', key: 'id', children: 'children' }
    const data =
      searchType === 1
        ? await service.common.getCategoryTree()
        : await service.common.getBrandList()
    setTreeLoading(false)
    setFieldNames(fieldNames)
    setTreeData(data)
  }

  const selectTree = (selectedKeys, e) => {
    onSelectChange([])
    setSelectTreeCode(selectedKeys[0])
    const params =
      searchType === 1
        ? { categoryCode: selectedKeys[0] }
        : { brandId: selectedKeys[0] }
    fetchData(
      Object.assign({ storeCode, storeId }, params, {
        pageIndex: 1,
        pageSize: 10
      })
    )
  }
  const confirmChoose = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请选择商品')
      return
    }
    confirm(selectedRowKeys)
    confirmListHaveInfo(selectedRows)
  }
  const columns = [
    {
      title: '商品信息',
      dataIndex: '',
      key: 'productInfo',
      render: (text, record, index) => (
        <>
          <div>{record.name}</div>
          <div>商品编码：{record.outProductNo}</div>
          <div>商品条码：{record.barcode}</div>
        </>
      )
    },
    { title: '商品类别', dataIndex: 'categoryName', key: 'categoryName' },
    { title: '商品品牌', dataIndex: 'brand', key: 'brand' },
    { title: '售价', dataIndex: 'salePrice', key: 'salePrice' },
    {
      title: '规格',
      dataIndex: 'specification',
      key: 'specification',
      render: (text, record) => (
        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
          {text}
        </div>
      )
    },
    { title: '单位', dataIndex: 'packageUnitName', key: 'packageUnitName' },
    {
      title: '状态',
      dataIndex: 'onShelves',
      key: 'onShelves',
      render: onShelves => statusMap[onShelves]
    }
  ]
  return (
    <Modal
      closable={false}
      maskClosable={true}
      visible={visible}
      width='70%'
      title=''
      onCancel={close}
      onOk={confirmChoose}
      cancelText='取消'
      okText='确认'>
      <Row>
        <Col span={6}>
          <Space
            direction='vertical'
            style={{ display: 'flex', width: '100%', paddingRight: '40px' }}>
            <Select
              defaultValue={1}
              onChange={setSearchType}
              style={{ width: '100%' }}>
              <Select.Option value={1}>商品类别</Select.Option>
              <Select.Option value={2}>商品品牌</Select.Option>
            </Select>
            {treeLoading ? (
              <Spin />
            ) : (
              <Tree
                className='brand-tree'
                style={{ textAlign: 'left' }}
                blockNode
                fieldNames={fieldNames}
                treeData={TreeData}
                onSelect={selectTree}
              />
            )}
          </Space>
        </Col>
        <Col span={18}>
          <Space direction='vertical' style={{ width: '100%' }}>
            <Form form={form} layout='inline'>
              {typeof create === 'function' ? (
                <Form.Item>
                  <Button
                    type='primary'
                    icon={<PlusOutlined />}
                    onClick={create}>
                    新增商品
                  </Button>
                </Form.Item>
              ) : (
                ''
              )}
              <Form.Item name='productInfo' label='商品信息'>
                <Input placeholder='商品名称/条码/商品编码' />
              </Form.Item>
              <Form.Item>
                <Button
                  type='primary'
                  ghost
                  icon={<SearchOutlined />}
                  onClick={onSearch}>
                  查询
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  type='primary'
                  ghost
                  icon={<ReloadOutlined />}
                  onClick={onReset}>
                  重置
                </Button>
              </Form.Item>
            </Form>
            <Table
              rowKey={record => record.skuId}
              loading={loading}
              dataSource={tableData}
              columns={columns}
              pagination={pagination}
              rowSelection={rowSelection}
              onChange={handleTableChange}
            />
          </Space>
        </Col>
      </Row>
      {!!otherTips && (
        <p style={{ margin: '20px 0 0', textAlign: 'right' }}>{otherTips}</p>
      )}
    </Modal>
  )
}
